import { action } from 'typesafe-actions';
import {
  BET_EDIT_FAILURE,
  BET_EDIT_REQUEST,
  BET_EDIT_SUCCESS,
  BETS_FAILURE,
  BETS_REQUEST,
  BETS_SUCCESS,
  CREATE_BET_FAILURE,
  CREATE_BET_REQUEST,
  CREATE_BET_SUCCESS,
} from '../../constants/bets';

export const betsRequestAction = (id: string) => action(BETS_REQUEST, id);
export const betsSuccessAction = (data: any) => action(BETS_SUCCESS, data);
export const betsFailureAction = (e: any) => action(BETS_FAILURE, e);

export const betEditRequestAction = (values: string) =>
  action(BET_EDIT_REQUEST, values);
export const betEditSuccessAction = (data: any) =>
  action(BET_EDIT_SUCCESS, data);
export const betEditFailureAction = (e: any) => action(BET_EDIT_FAILURE, e);

export const createBetRequestAction = (formData: any) =>
  action(CREATE_BET_REQUEST, formData);
export const createBetSuccessAction = (data: any) =>
  action(CREATE_BET_SUCCESS, data);
export const createBetFailureAction = (e: any) => action(CREATE_BET_FAILURE, e);

export const betsActions = {
  betEditRequestAction,
  betEditSuccessAction,
  betEditFailureAction,
  betsRequestAction,
  betsSuccessAction,
  betsFailureAction,
  createBetRequestAction,
  createBetSuccessAction,
  createBetFailureAction,
};
